import { Autocomplete } from '@Wonder-Cave/ui';
import { IDropdownValue } from '@Wonder-Cave/ui/dist/Autocomplete';
import { useClassifiedContactLists } from '@gr/portal/hooks/useContactListOptions';
import { useState } from 'react';

interface ISuppressionListDropdownProps {
  value: IDropdownValue[] | undefined;
  onChange: (newValue?: (IDropdownValue | undefined)[]) => void;
  onBlur?: () => void;
  allClients?: boolean;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError: boolean;
  gridFilter?: boolean;
  contactListIds: string[];
}

const SuppressionListDropdown = ({
  value,
  contactListIds,
  onChange,
  onBlur,
  disabled,
  errorMessage,
  showError,
}: ISuppressionListDropdownProps): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: contactListsData, isPending: contactListsLoading } = useClassifiedContactLists(searchTerm);

  const suppressionLists: IDropdownValue[] = [];

  // don't allow choosing contact list as suppression list if already selected as normal contact list
  // if user selects as suppression list first, then tries to select it as normal contact list, this should remove it as suppression
  if (value) {
    const removals: number[] = [];
    value.forEach((dropdownValue, idx) => {
      if (contactListIds.includes(dropdownValue.value)) {
        removals.push(idx);
      }
    });
    removals.forEach((idx) => value.splice(idx, 1));
  }

  contactListsData?.records
    .filter((contactList) => !contactListIds.includes(contactList.id))
    .map((contactList) => ({
      label: contactList.name ?? '',
      value: contactList.id,
      additionalData: contactList.originalFileName ?? '',
    }))
    .forEach((data) => suppressionLists.push(data));

  return (
    <Autocomplete
      label="Contact Lists"
      placeholder="Type to search for contact lists"
      loading={contactListsLoading}
      value={value}
      options={suppressionLists}
      onChange={onChange}
      onBlur={onBlur}
      refreshOptions={async (searchValue) => setSearchTerm(searchValue)}
      error={errorMessage}
      disabled={disabled}
      multiple
      showError={showError}
    />
  );
};

export default SuppressionListDropdown;
